import createReducer, { actions } from "./reducer";

export default createReducer;
export { actions };